import React, {useState} from 'react';
import { Col, Row, Segmented } from "antd";
import { packStockBySector, packStocksWithETFs } from "./utils/smaChartUtils";
import NivoCircleChart from "../../charts/nivo/NivoCircleChart";
import SectorLegend from "./Sectors/SectorLegend";
import {normalizeWeights} from "../../lib/weightSchemes";


const EtfCircleCharts = ({ condensedTickers, fullTickers, etfData }) => {
    const [view, setView] = useState('circle')
    const includedTickers = condensedTickers && condensedTickers.map(d=>d.symbol);
    let includedData = includedTickers && fullTickers.filter(d=>includedTickers.includes(d.symbol));
    let excludedData = includedTickers && fullTickers.filter(d=>!includedTickers.includes(d.symbol));
    includedData = normalizeWeights(includedData);
    excludedData = normalizeWeights(excludedData);
    const packedData = includedData && excludedData && packStockBySector(includedData, excludedData);
    const packedEtfData = etfData && packStocksWithETFs(etfData);
    const segmentConfig = [
      {
        label: "Circle",
        value: 'circle'
      },
        {
            label: "Stocks",
            value: 'stocks'
        }
    ]
    const ExtraLeft = ()=>(
        <Segmented options={segmentConfig} value={view} onChange={setView} className={'mx-3'}/>
    )
    return (
        <div className={'px-6'}>
          <Row justify={'center'} align={'middle'} gutter={64} wrap={false}>
            <Col flex={'0 0 300px'}>
              <SectorLegend data={packedData}/>
            </Col>
            <Col flex={'auto'}>
              {view === 'circle' && (
                  <div style={{height: 700, width: '100%'}} >
                    <NivoCircleChart data={packedData}
                                     extraLeft={<ExtraLeft/>}
                                     leavesOnly={true}
                    />
                  </div>
              )}
                {
                    view==='stocks'&& (
                        <div style={{height: 700, width: '100%'}}>
                            <NivoCircleChart data={packedEtfData}
                                             extraLeft={<ExtraLeft/>}
                                             leavesOnly={false}

                            />
                        </div>
                    )}

            </Col>
          </Row>
        </div>
    )

}


export default EtfCircleCharts